/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import RoundedButton from '../buttons/Rounded';
import SearchBar from '../forms/SearchBar';
import PageHeading from '../partials/PageHeading';

import styles from '../../../styles/headers/index-header.module.scss';

const propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    blocks: AppPropTypes.blocks,
    isDark: PropTypes.bool,
    withSearchBar: PropTypes.bool,
    searchClassName: PropTypes.string,
    setSearchValue: PropTypes.func,
    searchValue: PropTypes.string,
    buttonUrl: PropTypes.string,
    buttonLabel: AppPropTypes.message,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    description: null,
    blocks: null,
    isDark: false,
    withSearchBar: false,
    searchClassName: null,
    setSearchValue: null,
    searchValue: null,
    buttonUrl: null,
    buttonLabel: null,
    className: null,
};

const IndexHeader = ({
    title,
    description,
    blocks,
    isDark,
    withSearchBar,
    searchClassName,
    setSearchValue,
    searchValue,
    buttonUrl,
    buttonLabel,
    className,
}) => {
    const button =
        buttonUrl !== null && buttonLabel !== null ? (
            <RoundedButton href={buttonUrl} className={styles.button} isDark>
                {buttonLabel}
            </RoundedButton>
        ) : null;

    return (
        <div
            className={classNames(styles.container, [
                {
                    [className]: className !== null,
                },
            ])}
        >
            <PageHeading
                title={title}
                description={description}
                button={button}
                isDark={isDark}
                blocks={blocks}
                topClassName={styles.headingTop}
            >
                {description !== null ? <p className={styles.description}>{description}</p> : null}
                {withSearchBar ? (
                    <SearchBar
                        className={classNames([
                            styles.search,
                            { [searchClassName]: searchClassName !== null },
                        ])}
                        onChange={setSearchValue}
                        value={searchValue}
                        withRecentSearches
                    />
                ) : null}
            </PageHeading>
        </div>
    );
};

IndexHeader.propTypes = propTypes;
IndexHeader.defaultProps = defaultProps;

export default IndexHeader;
